// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'
import type { MarketDataSubscription } from '@innolab-trader/tradovate-types'
import type { SubscriptionErrorCode } from '@innolab-trader/tradovate-types/src/enums/subscriptionErrorCode'

export interface AddMarketDataSubscription {
  marketDataSubscriptionPlanIds: Array<number>
  year: number
  month: number
  creditCardId?: number
  accountId?: number
  userId?: number
}

export interface MarketDataSubscriptionResponse {
  errorText?: string
  errorCode?: SubscriptionErrorCode
  marketDataSubscription?: MarketDataSubscription
}

/**
 * Validate AddMarketDataSubscription request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateAddMarketDataSubscription(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateAddMarketDataSubscription(request: AddMarketDataSubscription): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.marketDataSubscriptionPlanIds === undefined || req.marketDataSubscriptionPlanIds === null) {
    errors.push({
      field: 'marketDataSubscriptionPlanIds',
      code: 'required',
      message: 'marketDataSubscriptionPlanIds is required'
    })
  }

  if (req.year === undefined || req.year === null) {
    errors.push({
      field: 'year',
      code: 'required',
      message: 'year is required'
    })
  }

  if (req.month === undefined || req.month === null) {
    errors.push({
      field: 'month',
      code: 'required',
      message: 'month is required'
    })
  }

  return errors
}

export const addMarketDataSubscription = postEndpoint<AddMarketDataSubscription, MarketDataSubscriptionResponse>('/user/addMarketDataSubscription')
